import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })

export default class UserConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointUsers() {
    return `${UserConfig.endpoint}/users`;
  }
  static get endpointUsersByEmailOrDU() {
    return `${UserConfig.endpointUsers}/usersByEmailOrDU`;
  }
  static get endpointUsersFromStorage() {
    return `${UserConfig.endpointUsers}/usersFromStorage`;
  }
  static get endpointSaveUser() {
    return `${UserConfig.endpointUsers}/save`;
  }
  static get endpointDeleteUser() {
    return `${UserConfig.endpointUsers}/delete`;
  }
  static get endpointSendNotification(){
    return `${UserConfig.endpointUsers}/sendNotification`
  }
  static get endpointDeliverys() {
    return `${UserConfig.endpointUsers}/deliverys`;
  }
  static get endpointActiveOrder() {
    return `${UserConfig.endpointUsers}/activeOrder`;
  }
  static get endpointOrderHistory() {
    return `${UserConfig.endpointUsers}/orderHistory`;
  }
  
  static get APIConnector() {
    return apiConnector
  }
}



// WEBPACK FOOTER //
// ./src/provider/user/UserConfig.js